import Icon from '../components/Icon.vue'

Icon.register({
  'poll-h': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 432V80C448 53.5 426.5 32 400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432zM112 192C103.2 192 96 184.8 96 176V144C96 135.2 103.2 128 112 128H240C248.8 128 256 135.2 256 144V176C256 184.8 248.8 192 240 192H112zM112 288C103.2 288 96 280.8 96 272V240C96 231.2 103.2 224 112 224H336C344.8 224 352 231.2 352 240V272C352 280.8 344.8 288 336 288H112zM112 384C103.2 384 96 376.8 96 368V336C96 327.2 103.2 320 112 320H176C184.8 320 192 327.2 192 336V368C192 376.8 184.8 384 176 384H112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poll-h.js
// module id = Eub5
// module chunks = 144